import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Scanner } from '@shared/definitions';

@Injectable({
  providedIn: 'root',
})
export class ScannerApiService {
  readonly scannerBaseUrl = '/api/v1.0/scanners';
  constructor(private http: HttpClient) {}
  addScanner(scanner: Omit<Scanner, 'id'>) {
    return this.http.post<Scanner>(`${this.scannerBaseUrl}`, scanner);
  }
  editScanner(scanner: Scanner) {
    return this.http.put(`${this.scannerBaseUrl}`, scanner);
  }
  getScanners(start: number, length: number, companyId: string) {
    // return this.http.get<{data: Event[], draw: number, recordFiltered: number, recordTotal: number}>(`${this.eventBaseUrl}`, {params:queryParams});
    let queryParams = new HttpParams();
    queryParams = queryParams.append('start', start.toString());
    queryParams = queryParams.append('length', length.toString());
    queryParams = queryParams.append('company', companyId);
    return this.http.get<{ data: Scanner[]; draw: number; recordFiltered: number; recordTotal: number }>(
      `${this.scannerBaseUrl}`,
      { params: queryParams }
    );
  }
  getScanner(id: string) {
    return this.http.get<Scanner>(`${this.scannerBaseUrl}/${id}`);
  }
  removeScanner(id: string) {
    return this.http.delete(`${this.scannerBaseUrl}/${id}`);
  }
  copyScanner(id: string) {
    return this.http.get(`${this.scannerBaseUrl}/${id}/copy`);
  }
  /* The login code as a QR PNG, which the scan app's login screen reads. A blob, not an <img src> URL: the
     endpoint is JWT-protected (the code is a login credential) and only HttpClient carries the token. */
  getScannerLoginQR(id: string) {
    return this.http.get(`${this.scannerBaseUrl}/${id}/code`, { responseType: 'blob' });
  }
}
